// extracted by css-extract-rspack-plugin
export default {"invisibleWithBorder":"ReposSelector-module__invisibleWithBorder__i5BXF","selected":"ReposSelector-module__selected__FxC9d"};